import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { UserContext } from '../../user/UserContext';
import { withFeatures } from '../../features/withFeatures';

export const RawNavReferral: FC = () => {
  const { currentUser, REFERRAL_AMOUNT } = useContext(UserContext);

  if (!currentUser.canHaveReferralCode) return null;

  return (
    <Hyperlink
      className="nav__item nav__item__desktop"
      href="/parrainage?source=nav"
    >
      <FormattedMessage
        id="navigation/pricing/NavReferral.tsx/1"
        values={{ amount: REFERRAL_AMOUNT }}
      />
    </Hyperlink>
  );
};

export const NavReferral = withFeatures('referral')(RawNavReferral);
